module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_4_1.18c48e77.png";